import React, { useEffect, useMemo } from 'react'
import { injectReducer } from 'store'
import reducer from './store'
import { useDispatch, useSelector } from 'react-redux'
import {
    getCompanyData,
    getConsignmentData,
    getFinacialInvoiceData,
    setCompanyTableData,
    setConsignmentTableData,
    setFinacialInvoiceTableData,
} from './store/dataSlice'
import { getCompanyData as getGlobalCompanyData } from 'store/data/dataSlice'
import { Tabs } from 'components/Ui'
import CompaniesTab from './components/CompaniesTab'
import ConsignmentTab from './components/ConsignmentTab'
import FinancialInvoicesTab from './components/FinancialInvoicesTab'
import dayjs from 'dayjs'

injectReducer('machship', reducer)

export default function Machship() {
    const dispatch = useDispatch()
    const {
        companyData,
        consignmentData,
        finacialInvoiceData,
        companyTableData,
        consignmentTableData,
        finacialInvoiceTableData,
        loading,
    } = useSelector(state => state.machship.data)

    // Use navbar company filter like in meson-wms pages
    const { company } = useSelector(state => state.filterData)
    const { companyData: globalCompanyData } = useSelector(state => state.listData)

    // Load global company data for filter options
    useEffect(() => {
        dispatch(getGlobalCompanyData())
    }, [dispatch])

    useEffect(() => {
        fetchCompanyData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dispatch,
        companyTableData.sort,
        companyTableData.query,
        companyTableData.pageIndex,
        companyTableData.pageSize,
        companyTableData.selectedTab,
        companyTableData.filters,
        company,
    ])

    useEffect(() => {
        fetchConsignmentData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dispatch,
        consignmentTableData.sort,
        consignmentTableData.query,
        consignmentTableData.pageIndex,
        consignmentTableData.pageSize,
        consignmentTableData.selectedTab,
        consignmentTableData.filters,
        company,
    ])

    useEffect(() => {
        fetchFinacialInvoiceData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dispatch,
        finacialInvoiceTableData.sort,
        finacialInvoiceTableData.query,
        finacialInvoiceTableData.pageIndex,
        finacialInvoiceTableData.pageSize,
        finacialInvoiceTableData.selectedTab,
    ])

    const fetchCompanyData = () => {
        console.log('Fetching company data with company:', company)
        console.log('Global company data:', globalCompanyData)
        const companyCode = company ? globalCompanyData?.find(item => item?.id?.toString() === company?.toString())?.code : ''
        console.log('Using company code:', companyCode)
        dispatch(
            getCompanyData({
                ...companyTableData,
                company: companyCode,
            })
        )
    }

    const fetchConsignmentData = () => {
        dispatch(
            getConsignmentData({
                ...consignmentTableData,
                company: company ? globalCompanyData?.find(item => item?.id?.toString() === company?.toString())?.code : '',
            })
        )
    }

    const fetchFinacialInvoiceData = () => {
        dispatch(getFinacialInvoiceData({ ...finacialInvoiceTableData }))
    }

    const columns1 = useMemo(
        () => [
            {
                field: 'name',
                header: 'Company Name',
                className: 'min-w-[150px]',
                orderable: true,
                hide: false,
            },
            {
                field: 'display_name',
                header: 'Display Name',
                className: 'min-w-[150px]',
                orderable: true,
                hide: false,
            },
            {
                field: 'id',
                header: 'Customer ID',
                className: 'min-w-[120px]',
                orderable: true,
                hide: false,
                renderCell: row => row?.id || 'N/A',
            },
            {
                field: 'account_code',
                header: 'Machship Account Code',
                className: 'min-w-[150px]',
                orderable: true,
                hide: false,
            },
            {
                field: 'maestro_company_id',
                header: 'Parent Company ID',
                className: 'min-w-[120px]',
                orderable: true,
                hide: false,
                renderCell: row => row?.maestro_company?.id || 'N/A',
            },
            {
                field: 'maestro_company_name',
                header: 'Parent Company',
                className: 'min-w-[150px]',
                orderable: true,
                hide: false,
                renderCell: row => row?.maestro_company?.name || 'No Parent Company',
            },
            {
                field: 'maestro_company_code',
                header: 'Parent Company Code',
                className: 'min-w-[120px]',
                orderable: true,
                hide: false,
                renderCell: row => row?.maestro_company?.code || 'N/A',
            },
        ],
        // eslint-disable-next-line
        [
            companyTableData.sort,
            companyTableData.query,
            companyTableData.pageIndex,
            companyTableData.pageSize,
            companyTableData.selectedTab,
            companyTableData.filters,
        ]
    )

    const columns2 = useMemo(
        () => [
            {
                field: 'consignment_number',
                header: 'Consignment Number',
                className: 'min-w-[150px]',
                orderable: true,
                hide: false,
            },
            {
                field: 'company.name',
                header: 'Company Name',
                className: 'min-w-[150px]',
                orderable: true,
                hide: false,
                renderCell: row => row?.company?.name || '',
            },
            {
                field: 'company.maestro_company.name',
                header: 'Parent Company',
                className: 'min-w-[150px]',
                orderable: true,
                hide: false,
                renderCell: row => row?.company?.maestro_company?.name || 'No Parent Company',
            },
            {
                field: 'carrier_and_service_name',
                header: 'Carrier & Service',
                className: 'min-w-[150px]',
                orderable: true,
                hide: false,
            },
            {
                field: 'consignment_tracking_status.name',
                header: 'Status',
                className: 'min-w-[150px]',
                orderable: true,
                hide: false,
                renderCell: row => row?.consignment_tracking_status?.name || '',
            },
            {
                field: 'created_date',
                header: 'Created Date',
                className: 'min-w-[150px]',
                orderable: true,
                hide: false,
                renderCell: row => (row?.created_date ? dayjs(row?.created_date).format('MMM D, YYYY') : ''),
            },
            {
                field: 'completed_date',
                header: 'Completed Date',
                className: 'min-w-[150px]',
                orderable: true,
                hide: false,
                renderCell: row => (row?.completed_date ? dayjs(row?.completed_date).format('MMM D, YYYY') : 'No'),
            },
            {
                field: 'carrier_consignment_id',
                header: 'Consignment Id',
                className: 'min-w-[150px]',
                orderable: true,
                hide: false,
            },
            {
                field: 'despatch_date',
                header: 'Delivery Date',
                className: 'min-w-[150px]',
                orderable: true,
                hide: false,
                renderCell: row => (row?.despatch_date ? dayjs(row?.despatch_date).format('MMM D, YYYY') : ''),
            },
        ],
        // eslint-disable-next-line
        [
            consignmentTableData.sort,
            consignmentTableData.query,
            consignmentTableData.pageIndex,
            consignmentTableData.pageSize,
            consignmentTableData.selectedTab,
            consignmentTableData.filters,
        ]
    )

    const columns3 = useMemo(
        () => [
            {
                field: 'document_number',
                header: 'Invoice',
                className: 'min-w-[150px]',
                orderable: true,
                hide: false,
            },
            {
                field: 'invoice_date',
                header: 'Date',
                className: 'min-w-[150px]',
                orderable: true,
                hide: false,
                renderCell: row => (row?.invoice_date ? dayjs(row?.invoice_date).format('MMM D, YYYY') : ''),
            },
            {
                field: 'total',
                header: 'Total Amount',
                className: 'min-w-[150px]',
                orderable: true,
                hide: false,
                renderCell: row => (row?.total ? `$${row?.total}` : ''),
            },
            {
                field: 'total_tax',
                header: 'Total Tax',
                className: 'min-w-[150px]',
                orderable: true,
                hide: false,
                renderCell: row => (row?.total_tax ? `$${row?.total_tax}` : ''),
            },
        ],
        // eslint-disable-next-line
        [
            finacialInvoiceTableData.sort,
            finacialInvoiceTableData.query,
            finacialInvoiceTableData.pageIndex,
            finacialInvoiceTableData.pageSize,
            finacialInvoiceTableData.selectedTab,
        ]
    )

    // Debug: Log the current data state
    console.log('Machship component render - companyData:', companyData)
    console.log('Machship component render - companyData length:', companyData?.length)
    console.log('Machship component render - company filter:', company)
    console.log('Machship component render - consignmentData:', consignmentData)
    console.log('Machship component render - consignmentData length:', consignmentData?.length)
    console.log('Machship component render - finacialInvoiceData:', finacialInvoiceData)
    console.log('Machship component render - finacialInvoiceData length:', finacialInvoiceData?.length)

    return (
        <>
            <div className="flex flex-col gap-1 mb-5 sm:flex-row sm:items-center sm:justify-between">
                <h2 className="font-semibold text-black text-title-md2 dark:text-white">Transport Management System</h2>
            </div>

            <Tabs.Group version={1}>
                <Tabs.List>
                    <Tabs>Companies</Tabs>
                    <Tabs>Consignment</Tabs>
                    {/* <Tabs>Financial Invoices</Tabs> */}
                </Tabs.List>
                <Tabs.Panels className="mt-4">
                    <Tabs.Panel>
                        <CompaniesTab
                            companyData={companyData}
                            companyTableData={companyTableData}
                            columns={columns1}
                            loading={loading}
                            company={company}
                            dispatch={dispatch}
                            setCompanyTableData={setCompanyTableData}
                        />
                    </Tabs.Panel>
                    <Tabs.Panel>
                        <ConsignmentTab
                            consignmentData={consignmentData}
                            consignmentTableData={consignmentTableData}
                            columns={columns2}
                            loading={loading}
                            company={company}
                            dispatch={dispatch}
                            setConsignmentTableData={setConsignmentTableData}
                        />
                    </Tabs.Panel>
                    <Tabs.Panel>
                        <FinancialInvoicesTab
                            finacialInvoiceData={finacialInvoiceData}
                            finacialInvoiceTableData={finacialInvoiceTableData}
                            columns={columns3}
                            loading={loading}
                            dispatch={dispatch}
                            setFinacialInvoiceTableData={setFinacialInvoiceTableData}
                        />
                    </Tabs.Panel>
                </Tabs.Panels>
            </Tabs.Group>
        </>
    )
}
